<template>
  <div style="height:100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.40" :split_height="156">
      <template #main>
        <TableMain ref="saleOrderDispatch1" name="myName" :fields="fields" :title="table_title.title1"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
          :show_toolbar="false" :show_filter="true" :selectable="true" @on_query="on_query" :isBusy="isBusy_table1"
          @current_changed="current_changed" :table_height_adjust="-8" :show_toolbar_state="true"
          :hb_table_class="'hb_table_sods_add_class1'" :loading_width="45" :only_text="$t('common.show_all')"
          @only_methods="only_main_methods">
          <template #query>
            <el-input :placeholder="$t('common.customer') + $t('common.name')" size="small" style="width: 160px"
              v-model="SalesName" clearable></el-input>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="saleOrderDispatch2" :show_query_container="false" :isBusy="isBusy_table2" :fields="item_fields"
          :show_date_picker="false" :table_height_adjust="8" :title="table_title.title2"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="true" :pager_count="5"
          :hb_table_class="'hb_table_sods_add_class2'" :loading_width="80" :show_toolbar_state="true"
          :only_text="$t('common.show_all')" @only_methods="only_methods">
          <template #toolbar>
            <el-select filterable reserve-keyword @change="remoteVendPriceMethod(vend_price_state, false)" class="ml-2"
              v-model="vend_price_state" style="width: 10rem">
              <el-option v-for="(item, index) in price_options" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="saleOrderDispatch3" :fields="saleOrderItems_Detail_fileds" :isBusy="isBusy_table3"
          :show_query_container="false" :title="table_title.title3" :date_picker_label="date_picker_label"
          :table_height_adjust="-1" :show_filter="false" :show_toolbar_state="true" :show_pagination="show_pagination"
          :pager_count="5" :loading_width="65" @on_input="saleOrderDispatch3_on_input"
          @on_change="saleOrderDispatch3_on_change" @state_change="table3_state_change"
          :show_toolbar_button="[0, 0, 0, 0, 1]" @item_drop_click="item_drop_click"
          @on_cell_button_click="on_cell_button_click" @item_drop_commond="item_drop_commond"
          :hb_table_class="'hb_table_sods_add_class3'">
          <template #toolbar>
            <el-select filterable clearable multiple collapse-tags reserve-keyword :placeholder="$t('common.provider')"
              :filter-method="remoteVenderMethod" class="ml-2" v-model="venders" style="width: 25rem"
              @clear="remoteVenderMethod" @remove-tag="remoteVenderMethod(venders)" @focus="remoteVenderMethod('')">
              <el-option v-for="(item, index) in vender_options" :key="index"
                :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum">
              </el-option>
            </el-select>
            <el-checkbox class="ml-2" :label="$t('common.all_provider')" v-model="isAllVender"></el-checkbox>
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddDispatch"><i
                class="fa fa-plus"></i></el-button>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveDispatch"
              :label="$t('common.save')" class="ml-2">
            </QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="choseVendData" :width="'60%'"
      :saveButtonTitle="$t('common.ok')">
      <template #modal_content>
        <BaseContainer style="height:100%" class="one_table">
          <div>
            <TableMain ref="VendQuoteTable" name="myName" :id="'vend_quote'" :fields="vendQuote_fields"
              :title="vendQuoteModal_title" :date_picker_label="date_picker_label" :query_button_label="query_lable"
              :show_query_container="false" :show_date_picker="true" :show_toolbar="true" :show_filter="true"
              :selectable="true" :loading_width="85" :isBusy="isBusy_VendQuoteTable" @on_input="VendQuoteTable_on_input"
              @on_change="VendQuoteTable_on_change" @item_select_change="item_select_change" :table_height_adjust="8"
              :table_height_default="'calc(100vh - 520px)'" :hb_table_class="'hb_table_vend_quote_add_class'">
              <template #toolbar>
                <el-select filterable reserve-keyword @change="remoteVendPriceMethod(modal_vend_price_state, true)"
                  class="ml-2" v-model="modal_vend_price_state" style="width: 10rem">
                  <el-option v-for="item in modal_price_options" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </TableMain>
          </div>
        </BaseContainer>
      </template>
    </BaseModal>
    <!-- 进度 -->
    <BaseModal ref="progressModal" :title="progress_modal_title" :hideFooter="true" :show_close="false" :top="'40vh'">
      <template #modal_content>
        <BaseProgress ref="progress"></BaseProgress>
      </template>
    </BaseModal>
    <!-- 附件 -->
    <el-dialog title="附件管理" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" @opened="dialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'SalesDispatch'" @setAccessory="setAccessory"></FileUpload>
    </el-dialog>
  </div>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as VendTableController from "../../controllers/base/VendTableController"
import * as commonController from "../../controllers/commonController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as VendPurchaseQuoteOutController from "../../controllers/sd/VendPurchaseQuoteOutController"
import * as saleOrderDispatchAddController from "../../controllers/sd/saleOrderDispatchAddController"
import * as saleOrderDispatchItemsController from "../../controllers/sd/saleOrderDispatchItemsController"
import * as SaleOrderDispatchSearchController from "../../controllers/sd/saleOrderDispatchSearchController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as notify_template from "../../shared/notify_template"
import FileUpload from "../FileUpload.vue"
import BaseContainer from "../components/BaseContainer"
import BaseProgress from "../components/base/BaseProgress"
import EntityEditor from "../components/base/EntityEditor"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer2 from "../components/container/SplitContainer2"
import SplitContainer3 from "../components/container/SplitContainer3"
import SplitContainer4 from "../components/container/SplitContainer4"
import BaseModal from "../components/modals/baseModal"
import TableDetail from "../components/table/TableDetail"
import TableMain from "../components/table/TableMain"

export default {
  name: "SOSalesQuote",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer4,
    SplitContainer3,
    SplitContainer2,
    BaseModal,
    BaseProgress,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sales_order",
        title2: "table_sales_order_detail",
        title3: "table_create_dispatch",
      },
      modal_title: "",
      vendQuoteModal_title: "table_create_dispatch",//table_vend_purch_price
      progress_modal_title: this.$t("common.progress"),
      fields: saleOrderDispatchAddController.fields.default,
      item_fields: saleOrderDispatchAddController.fields.item_fields,
      saleOrderItems_Detail_fileds:
        saleOrderDispatchAddController.fields.saleOrderItems_Detail_fileds,
      vendQuote_fields: saleOrderDispatchAddController.fields.vend_quote_fileds,
      show_pagination: false,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      isBusy_VendQuoteTable: false,
      SalesName: "",
      company_options: [],
      vender_options: [],
      vender_his_options: [],
      so_all_has_price_vends: [],//订单下所有物料对应的有报价的供应商
      company_id: [],
      venders: [],
      taxgroup_options: [],
      soHisData: [],
      selectItem: null,
      current_dispatch_line: null, ///当前派单选中行
      current_accessory: null, ///当前派单选中附件
      so_item_his: [],
      so_current_item: null,
      has_quote_vend_list_his: [],
      all_role_users: [],
      vend_price_state: "vend_price",
      modal_vend_price_state: "vend_price",
      selectSOLineItems: [],
      price_options: [{
        value: 'all',
        label: '全部'
      }, {
        value: 'vend_price',
        label: '有实际报价'
      }, {
        value: 'initial_price',
        label: '仅有初始报价'
      }],
      modal_price_options: [{
        value: 'vend_price',
        label: '有实际报价'
      }, {
        value: 'initial_price',
        label: '仅有初始报价'
      }],
      isAllVender: false,
      accessoryVisible: false,
      temp_add_list: []
    }
  },
  activated() { },
  deactivated() { },
  async created() {
    let _this = this
    let _field = _.find(this.saleOrderItems_Detail_fileds, {
      key: "AccountNum",
    })
    _field["_dropoptions"] = {
      base_on_field: "AccountNum",
      provider: (v, item) => {
        return _this.setVendOptionsData(v, item)
      },
    }
    await this.getAllRoleUsers()
  },

  mounted() {
    this.getOptions()
  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //预加载部分options
    getOptions() {
      if (this.$store.state.biz_data.baseData.CompanyInfo) {
        this.company_options = _.cloneDeep(
          this.$store.state.biz_data.baseData.CompanyInfo
        ).splice(0, 300)
      }
      if (this.$store.state.biz_data.baseData.Vender) {
        this.vender_options = _.cloneDeep(
          _.orderBy(
            this.$store.state.biz_data.baseData.Vender,
            ["modifiedDateTime"],
            ["desc"]
          )
        ).splice(0, 300)
      }
    },
    //公司选择
    remoteMethod(query) {
      if (query !== "") {
        this.loadingSelected = true
        this.company_options = _.cloneDeep(
          this.$store.state.biz_data.baseData.CompanyInfo.filter((item) => {
            return (
              item.DataArea.toLowerCase().indexOf(query.toLowerCase()) > -1
            )
          })
        ).splice(0, 300)
        this.loadingSelected = false
      } else {
        let data = _.cloneDeep(
          this.$store.state.biz_data.baseData.CompanyInfo
        ).splice(0, 300)
        this.company_options = data
      }
    },
    //供应商选择
    remoteVenderMethod(query) {
      if (_.isArray(query)) {
        if (query.length == 0) {
          query = ""
        } else {
          return
        }
      }
      let only_item_selected = _.filter(this.vender_his_options, (t) => {
        if (t.itemId == "") {
          return t
        }
        else {
          let so_current = this.$refs.saleOrderDispatch1.GetCurrentItem()
          let so_item_selected = this.$refs.saleOrderDispatch2.GetSelectedItems()
          for (var i in so_item_selected) {
            if (so_current.fcCheckIfSOItemHasVendPrice && so_item_selected[i].ItemId == t.itemId && t.is_only_initial == 0) {
              return t
            }
          }
        }
      })
      let data = []
      if (query && query !== "") {
        this.loadingSelected1 = true
        let vender_list = []
        if (this.isAllVender) {
          vender_list = _.cloneDeep(this.$store.state.biz_data.baseData.Vender)
          let all_vender = _.filter(this.$store.state.biz_data.baseData.AllVender, (t) => {
            if (t.Blocked == "否" && t.dataAreaId == this.so_current_item.dataAreaId) {
              return t
            }
          })
          vender_list = _.filter(vender_list, (t) => {
            let _index = _.findIndex(all_vender, (m) => {
              return m.AccountNum == t.AccountNum
            })
            if (_index > -1) {
              return t
            }
          })
        }
        else {
          vender_list = _.orderBy(
            only_item_selected,
            ["modifiedDateTime"],
            ["desc"]
          )
        }
        let _filter_list = vender_list.filter((item) => {
          return (
            item.AccountNum.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
            item.SEI_Name.indexOf(query) > -1
          )
        })
        data = _.cloneDeep(_filter_list).splice(0, 100)
        this.loadingSelected1 = false
      } else {
        if (this.isAllVender) {
          data = _.cloneDeep(this.$store.state.biz_data.baseData.Vender)
          let all_vender = _.filter(this.$store.state.biz_data.baseData.AllVender, (t) => {
            if (t.Blocked == "否" && t.dataAreaId == this.so_current_item.dataAreaId) {
              return t
            }
          })
          data = _.filter(data, (t) => {
            let _index = _.findIndex(all_vender, (m) => {
              return m.AccountNum == t.AccountNum
            })
            if (_index > -1) {
              return t
            }
          })
          data = _.cloneDeep(data).splice(0, 300)
        }
        else {
          data = _.cloneDeep(
            _.orderBy(only_item_selected, ["modifiedDateTime"], ["desc"])
          ).splice(0, 300)
        }
      }
      this.vender_options = _.uniqBy(data, "AccountNum")
    },
    //供应商报价筛选
    //筛选下拉时筛选的是有实际报价的供应商
    async remoteVendPriceMethod(state_code, is_modal) {
      let _table_ref = ""
      if (is_modal) {
        _table_ref = "VendQuoteTable"
        let is_only_initial = state_code == "vend_price" ? 0 : 1
        let list = _.filter(this.has_quote_vend_list_his, { is_only_initial: is_only_initial })
        this.$refs.VendQuoteTable.SetData(_.orderBy(list, ["price"], ["asc"]))
      }
      else {
        _table_ref = "saleOrderDispatch2"
        let show_dt = this.so_item_his
        if (state_code == "vend_price") {
          let so_current = this.$refs.saleOrderDispatch1.GetCurrentItem()
          if (so_current && !so_current.fcCheckIfSOItemHasVendPrice) {
            show_dt = []
          }
          else {
            show_dt = _.filter(this.so_item_his, (t) => {
              let _index = _.findIndex(this.so_all_has_price_vends, { itemId: t.ItemId, is_only_initial: 0 })
              if (_index > -1) {
                return t
              }
            })
          }
        }
        else if (state_code == "initial_price") {
          show_dt = _.filter(this.so_item_his, (t) => {
            let _index = _.findIndex(this.so_all_has_price_vends, (v) => {
              return t.ItemId == v.itemId && v.is_only_initial == 1
            })
            let _only_index = _.findIndex(this.so_all_has_price_vends, (v) => {
              return t.ItemId == v.itemId && v.is_only_initial == 0
            })
            if (_index > -1 && _only_index < 0) {
              return t
            }
          })
        }
        show_dt = _.filter(show_dt, (t) => {
          if (this.$refs.saleOrderDispatch2.only_value) {
            return t.valid_remain >= 0
          }
          else {
            return t.valid_remain > 0
          }
        })

        this.$refs.saleOrderDispatch2.SetData(show_dt)
      }
    },
    ///查询
    async on_query(set_data, date_range) {
      set_data([])
      let _this = this
      this.selectItem = null
      this.$refs.saleOrderDispatch2.SetData([])
      this.$refs.saleOrderDispatch3.SetData([])
      this.isBusy_table1 = true
      let _fromDate = "",
        _toDate = ""
      let _params = {
        is_deleted: { "=": 0 },
        SalesName: { like: "%" + this.SalesName + "%" },
      }
      if (!_.isNull(date_range) && this.SalesName == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }
      let _result = await saleOrderDispatchAddController.methods.getData(
        _params
      )
      console.log(_result)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = []
        _.each(_result[0], (t) => {
          let _index = _.findIndex(
            _this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccount }
          )
          if (_index > -1 && t.fcCheckSOAllApproved == true) {
            t.DeliveryDate = _this.formatDate(t.DeliveryDate)
            _list.push(t)
          }
          t._error = !t.fcCheckIfSOItemHasVendPrice
        })
        this.soHisData = _.orderBy(_list, ["id"], ["desc"])
        this.only_main_methods(this.$refs.saleOrderDispatch1.only_value)
      }
      this.isBusy_table1 = false
    },
    ///销售订单选择
    async current_changed(old, current) {
      this.so_current_item = _.cloneDeep(current)
      this.vender_options = []
      this.vender_his_options = []
      this.so_all_has_price_vends = []
      this.so_item_his = []
      this.vend_price_state = "vend_price"
      if (_.isNull(current)) {
        this.$refs.saleOrderDispatch3.SetData([])
        this.$refs.saleOrderDispatch2.SetData([])
        return
      }

      this.$refs.saleOrderDispatch2.SetData([])
      this.$refs.saleOrderDispatch3.SetData([])
      this.venders = []

      this.isBusy_table2 = true
      await this.getItems(this.$refs.saleOrderDispatch2.only_value)
      this.isBusy_table2 = false
      await this.getVenders(current)
      this.remoteVendPriceMethod(this.vend_price_state, false)
    },
    ///获取供应商
    async getVenders(current) {
      let _result = await VendTableController.methods.getItemOptions({
        dataAreaId: { "=": current.dataAreaId },
        Blocked: { "=": "否" }
      })
      let dt = []
      if (!_.isNull(_result) && _result && _result.length > 0) {
        dt = _.cloneDeep(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))

      }
      let all_vend_list = []
      let soline_list = _.filter(this.so_item_his, (t) => { return t.valid_remain > 0 })
      for (var i in soline_list) {
        let _list = []
        let quoted_vend_list = await saleOrderDispatchAddController.methods.getHasQuoteVends({
          ItemId: soline_list[i].ItemId,
          currency: soline_list[i].CurrencyCode
        })
        if (quoted_vend_list && quoted_vend_list[0] &&
          quoted_vend_list[0].Result.Data &&
          quoted_vend_list[0].Result.Data.length > 0 &&
          quoted_vend_list[0].Result.Data[0]) {
          _list = quoted_vend_list[0].Result.Data[0]
        }
        all_vend_list = _.union(all_vend_list, _list)
      }

      this.so_all_has_price_vends = all_vend_list
      let vt = []
      for (var k in all_vend_list) {
        let t = all_vend_list[k]
        let _ix = _.findIndex(vt, { AccountNum: t.AccountNum, itemId: t.itemId })
        if (_ix < 0) {
          if (current.SalesPoolId === "测试打样" || current.SalesPoolId === "样品销售") {
            if (t.quotationType === "打样报价")
              vt.push(t)
          }
          else if (t.quotationType !== "打样报价")
            vt.push(t)
        }
      }
      let vender_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { DataArea: current.dataAreaId })
      if (vender_m) {
        let vmv = {
          AccountNum: vender_m.VenderAccountNum,
          SEI_Name: vender_m.CompanyName,
          is_only_initial: 0,
          itemId: "",
          quotationType: "大货报价"
        }
        let _index = _.findIndex(vt, { AccountNum: vender_m.VenderAccountNum })
        if (_index < 0) {
          vt.unshift(vmv)
        }
      }
      this.vender_options = vt
      this.vender_his_options = vt
    },
    async getItems(isAll) {
      let current = this.$refs.saleOrderDispatch1.GetCurrentItem()
      if (!current) {
        this.msgToasts(this.$t("notify.not_selected_sales_order"), "info")
        return
      }
      let _p = {
        SalesTable_id: current.id,
      }
      let _result = await saleOrderDispatchAddController.methods.getItemData(
        _p
      )

      if (!_.isNull(_result) && _result && _result.length > 0) {

        let _list = _.filter(_.orderBy(_result[0], ["LineNum"], ["asc"]), { is_deleted: false })
        this.so_item_his = _list
      }
    },
    async getRelatedPrice(item) {
      let plist = []
      let so_m = this.$refs.saleOrderDispatch1.GetCurrentItem()
      plist.push({
        itemId: item.ItemId,
        currency: item.CurrencyCode ? item.CurrencyCode : item.PurchCurrencyCode,
        dataAreaId: so_m.dataAreaId,
        accountNum: so_m.CustAccount,
        vendAccountNum: item.AccountNum == "" ? null : item.AccountNum,
        qty: item.qty
      })
      // _.each(list, (item) => {
      //   plist.push({
      //     itemId: item.ItemId,
      //     currency: item.CurrencyCode ? item.CurrencyCode : item.PurchCurrencyCode,
      //     dataAreaId: so_m.dataAreaId,
      //     accountNum: so_m.CustAccount,
      //     vendAccountNum: item.AccountNum == "" ? null : item.AccountNum,
      //     qty: item.qty
      //   })
      // })

      let result = await VendPurchaseQuoteOutController.methods.getPriceRelated(plist)
      if (result && result.length > 0 && result[0] && result[0].Result && result[0].Result.Data
        && result[0].Result.Data.length > 0 && result[0].Result.Data[0]) {
        let pm_list = result[0].Result.Data
        let pm = pm_list[0][0]
        item.Initial_Vend_Price = pm.initial_vend_price//初始报价
        item.Initial_Vend_Price_WOTax = pm.initial_vend_price_wotax//初始报价本币净单价
        item.Vend_Price = pm.vend_price//供应商报价确认
        item.Vend_Price_WOTax = pm.vend_price_wotax//供应商报价确认本币净单价
        item.Sales_Doc_Price = pm.salesPrice//协议价格
        item.Sales_Cost = pm.salesCost//成本
        item.Vend_Cost = pm.vend_cost//供应商成本
        item.PurchCurrencyCode = pm.vend_price_currency//供应商报价确认币种
        item.Initial_Vend_Price_Currency = pm.initial_vend_price_currency//供应商初始报价币种
        item.Price_Remark = pm.price_remark//实际采购价备注
        // for (var i in pm_list) {
        //   let pm = pm_list[i][0]
        //   list[i].Initial_Vend_Price = pm.initial_vend_price;//初始报价
        //   list[i].Initial_Vend_Price_WOTax = pm.initial_vend_price_wotax;//初始报价本币净单价
        //   list[i].Vend_Price = pm.vend_price;//供应商报价确认
        //   list[i].Vend_Price_WOTax = pm.vend_price_wotax;//供应商报价确认本币净单价
        //   list[i].Sales_Doc_Price = pm.salesPrice;//协议价格
        //   list[i].Sales_Cost = pm.salesCost;//成本
        //   list[i].Vend_Cost = pm.vend_cost;//供应商成本
        //   list[i].PurchCurrencyCode = pm.vend_price_currency;//供应商报价确认币种
        //   list[i].Initial_Vend_Price_Currency = pm.initial_vend_price_currency;//供应商初始报价币种
        //   list[i].Price_Remark = pm.price_remark;//实际采购价备注
        // }
      }
    },
    //添加派发
    async AddDispatch() {
      this.selectSOLineItems = _.cloneDeep(this.$refs.saleOrderDispatch2.GetSelectedItems())
      this.remoteVenderMethod('')
      if (this.selectSOLineItems.length == 0) {
        this.msgToasts(this.$t("notify.not_selected_sales_order_detail"), "warning")
        return
      }

      if (this.selectSOLineItems && this.selectSOLineItems.length > 0) {
        this.isBusy_table3 = true
        this.saleOrderChooseBatch()
      } else {
        this.msgToasts(this.$t("notify.not_selected_sales_order_detail"), "warning")
      }
    },
    //批量添加派发
    async saleOrderChooseBatch() {
      let _this = this
      let _append_items = []
      let order_seq = this.$refs.saleOrderDispatch3.my_data.length
      _.each(_this.selectSOLineItems, (d) => {
        let _m = _.cloneDeep(saleOrderDispatchAddController.dataForm)
        _m.id = ""
        _m.AccountNum = ""
        _m.SEI_Name = ""
        _m.SalesLineId = d.id //销售订单明细id
        _m.ItemId = d.ItemId
        _m.NameAlias = d.NameAlias
        _m.price = 0
        _m.price_vend = 0
        _m.Cost_Sum = 0
        _m.qty = d.valid_remain
        _m.SalesQty = d.SalesQty
        _m.Capacity = 0
        _m.delivery_date = _this.$date.format(
          new Date(d.ConfirmedDlv),
          "yyyy-MM-dd"
        )
        _m.RetailVariantId = d.RetailVariantId
        _m.VariantName = d.VariantName
        _m.LineNum = d.LineNum
        _m.profit_value = d.SalesPriceWOTax//d.SalesPrice

        _m.Sales_Order_Price = d.SalesPriceWOTax//d.SalesPrice;
        _m.PurchCurrencyCode = "CNY"
        _m.isNullPurchPrice = _this.isAllVender

        if (_this.venders.length > 0) {
          _.each(_this.venders, (t) => {
            let _mv = _.cloneDeep(_m)
            _mv.order_seq = order_seq
            order_seq += 1
            ///供应商相关信息
            let vend_m = _.find(_this.$store.state.biz_data.baseData.Vender, {
              AccountNum: t,
            })
            if (vend_m) {
              _mv.AccountNum = vend_m.AccountNum
              _mv.SEI_Name = vend_m.SEI_Name
              _mv.TotalScore = vend_m.TotalScore
              _mv.TaxGroup = vend_m.TaxGroup
            }
            _append_items.push(_mv)
          })
        } else {
          _m.order_seq = order_seq
          order_seq += 1
          _append_items.push(_.cloneDeep(_m))
        }
      })
      this.temp_add_list = _append_items
      this.$refs.saleOrderDispatch3.AppendItems(_append_items)
      if (this.$refs.saleOrderDispatch3.my_data.length > 50)
        this.show_pagination = true

      await this.setDisDataStateAndInfo("saleOrderDispatch3")
      ///显示预分配比例
      let _somain_current = this.$refs.saleOrderDispatch1.GetCurrentItem()
      let _quotationType = "大货报价"
      if (_somain_current.SalesPoolId === "测试打样" || _somain_current.SalesPoolId === "样品销售") {
        _quotationType = "打样报价"
      }
      let pre_params = _.map(this.$refs.saleOrderDispatch3.my_data, (t) => { return { AccountNum: t.AccountNum, ItemId: t.ItemId, dataAreaId: _somain_current.dataAreaId, quotationType: _quotationType } })
      pre_params = _.uniqWith(pre_params, _.isEqual)
      let rt_pre_dis = await saleOrderDispatchAddController.methods.getPreDistributionInDispatch(pre_params)
      if (rt_pre_dis && rt_pre_dis.length > 0) {
        for (var k in rt_pre_dis) {
          if (rt_pre_dis[k][0]) {
            let drlist = _.filter(this.$refs.saleOrderDispatch3.my_data, { AccountNum: rt_pre_dis[k][0].AccountNum, ItemId: rt_pre_dis[k][0].ItemId })
            if (drlist && drlist.length > 0) {
              _.each(drlist, (mt) => {
                mt.PreDistributRate = rt_pre_dis[k][0].DistributionRate
              })
            }
          }
        }
      }
      this.isBusy_table3 = false
      this.temp_add_list = []
    },
    ///获取或设置派单相关信息
    async setDisDataStateAndInfo(table_ref, woFields, current_item) {
      let action_list = this.$refs[table_ref].my_data
      if (this.temp_add_list.length > 0) {
        let orderSeqs = _.map(this.temp_add_list, (t) => { return t.order_seq })
        action_list = _.filter(this.$refs[table_ref].my_data, (t) => {
          return _.includes(orderSeqs, t.order_seq)
        })
      }

      let _p = {
        check_vend_has_invent: [],
        get_pc: [],
        amount_tax: [],
        invent_sum_params: [],
      }, pt = []

      ///整理数据
      if (current_item) {
        pt.push(current_item)
        //检查是否包含物料
        let _companyid = 0

        //查找供应商公司编码
        let _company = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          VenderAccountNum: current_item.AccountNum,
        })
        if (_company) {
          _companyid = _company.DataArea
        }
        _p.check_vend_has_invent.push({
          dataAreaId: _companyid,
          ItemId: current_item.ItemId,
          _seq: current_item.order_seq,
        })

        ///获取产能
        _p.get_pc.push({
          AccountNum: current_item.AccountNum,
          delivery_date: current_item.delivery_date,
          _seq: current_item.order_seq,
        })

        ///供应商现有库存量
        let _invent_sum_m = {
          AccountNum: current_item.AccountNum,
          ItemId: current_item.ItemId,
          _seq: current_item.order_seq,
        }
        _p.invent_sum_params.push(_invent_sum_m)
      } else {
        pt = action_list
        for (var i in action_list) {
          let t = action_list[i]
          //检查是否包含物料
          let _companyid = 0
          //查找供应商公司编码
          let _company = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
            VenderAccountNum: t.AccountNum,
          })
          if (_company) {
            _companyid = _company.DataArea
          }
          _p.check_vend_has_invent.push({
            dataAreaId: _companyid,
            ItemId: t.ItemId,
            _seq: t.order_seq,
          })

          ///获取产能
          _p.get_pc.push({
            AccountNum: t.AccountNum,
            delivery_date: t.delivery_date,
            _seq: t.order_seq,
          })

          ///供应商现有库存量
          let _invent_sum_m = {
            AccountNum: t.AccountNum,
            ItemId: t.ItemId,
            _seq: t.order_seq,
          }
          _p.invent_sum_params.push(_invent_sum_m)
        }
      }
      //设置价格
      await this.setItemPrice(pt, table_ref, woFields)

      let loading = null
      if (!current_item && this.$refs[table_ref].my_data.length > 100) {
        loading = this.$loading({
          lock: true,
          text: this.$t("notify.searching_price_capacity"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
      }
      let _result = await saleOrderDispatchAddController.methods.getDisDataStateAndInfo(_p)
      if (!_.isNull(_result) && _result) {
        if (!current_item && this.$refs[table_ref].my_data.length > 100) {
          loading.setText(this.$t("notify.init_price_capacity"))
          this.$forceUpdate()
        }
        let m_setting = []
        ///设置产能
        let _filter_pc = _.filter(_result, {
          Code: "data/e/get_vend_production_capacity",
        })
        _.each(_filter_pc, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            if (t.Result.Data && !_.isNull(t.Result.Data)) {
              for (var i in t.Result.Data) {
                let _seq = t.Params[i]._seq
                if (current_item) {
                  _seq = current_item.order_seq
                }
                // let _m = _.cloneDeep(_.find(_table3_list, { order_seq: _seq }));
                let _m = {}
                _m.Capacity = _.round(t.Result.Data[i][0].ProductionCapacity, 2)
                m_setting.push({
                  by: { order_seq: _seq },
                  m: _m,
                  wf: woFields
                })
              }
            }
          }
        })
        ///检查是否包含物料
        let _filter_has = _.filter(_result, {
          Code: "data/e/check_isExiste_vend_item",
        })
        _.each(_filter_has, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            if (t.Result.Data && !_.isNull(t.Result.Data)) {
              for (var i in t.Result.Data) {
                let _seq = t.Params[i]._seq
                if (current_item) {
                  _seq = current_item.order_seq
                }
                // let _m = _.cloneDeep(_.find(_table3_list, { order_seq: _seq }));
                let _m = {}
                if (t.Params.dataAreaId != 0 && t.Result.Data[i][0].is_check_ok != 0) {
                  _m._error = true
                  m_setting.push({
                    by: { order_seq: _seq },
                    m: _m,
                    wf: ["qty", "price", "delivery_date"]
                  })
                }
              }
            }
          }
        })

        ///查询现有库存量
        let _filter_invent_sum = _.filter(_result, {
          Code: "data/e/get_vend_invent_sum",
        })
        _.each(_filter_invent_sum, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            for (var i in t.Result.Data) {
              let _seq = t.Params[i]._seq
              if (current_item) {
                _seq = current_item.order_seq
              }
              let _m = {}
              if (_m && t.Result.Data && !_.isNull(t.Result.Data)) {
                if (!_.isNull(t.Result.Data[i][0].AvailPhysical)) {
                  _m.invent_sum = _.round(t.Result.Data[i][0].AvailPhysical, 6)
                }
              }
              m_setting.push({
                by: { order_seq: _seq },
                m: _m,
                wf: woFields
              })
            }
          }
        })
        _.each(m_setting, (item) => {
          this.$refs[table_ref].UpdateItemsWOField(item.by, item.m, item.wf)
        })
        if (!current_item && this.$refs[table_ref].my_data.length > 100) {
          loading.close()
        }

      }

    },
    async setItemPrice(pt, table_ref, woFields) {
      //初始化报价和成本
      ///毛利区间
      let _profit_value = null
      let _profit_m = _.find(
        this.$store.state.biz_data.baseData.SystemSetting,
        { code: "profit_setting" }
      )
      if (_profit_m && _profit_m.setting_value != "")
        _profit_value = JSON.parse(_profit_m.setting_value)

      _.each(pt, async (mt) => {
        await this.getRelatedPrice(mt)
        mt.price = mt.Vend_Price == -1 ? "" : mt.Vend_Price
        mt.price_wotax = mt.Vend_Price_WOTax == -1 ? "" : mt.Vend_Price_WOTax//供应商报价确认本币净单价
        mt.price_vend = mt.Initial_Vend_Price == -1 ? "" : mt.Initial_Vend_Price//初始报价
        mt.price_vend_wotax = mt.Initial_Vend_Price_WOTax == -1 ? "" : mt.Initial_Vend_Price_WOTax//初始报价本币净单价

        mt.price_vend_currency = mt.Initial_Vend_Price_Currency//供应商初始报价币种
        mt.price_remark = mt.Price_Remark//实际采购价备注
        mt.quote_state = 2
        mt.Cost_Sum = mt.Vend_Cost == -1 ? "" : mt.Vend_Cost
        if (mt.price != -1 && !_.isNull(mt.price) && mt.price != "") {
          mt.isNullPurchPrice = false
        }
        if (mt.price != mt.price_vend) {
          mt.quote_state = 0
        } else {
          mt.quote_state = 2
        }
        //不是本币时要转换为本币
        let _sales_price = mt.Sales_Order_Price

        //不是本币时要转换为本币
        let _temp_price = mt.price_wotax == "" ? 0 : mt.price_wotax

        let _profit = 0
        if (_temp_price > 0) {
          _profit = ((parseFloat(_sales_price) - parseFloat(_temp_price)) / parseFloat(_sales_price)) * 100
        }
        mt.profit_state = 2
        mt.profit_value = _.round((parseFloat(_sales_price) - parseFloat(_temp_price)), 6)
        if (!_.isNull(_profit_value)) {
          if (_profit < parseFloat(_profit_value.minProfit)) {
            mt.profit_state = 0
          } else if (_profit < parseFloat(_profit_value.maxProfit)) {
            mt.profit_state = 1
          } else if (_profit >= parseFloat(_profit_value.maxProfit)) {
            mt.profit_state = 2
          }
        }
        this.$refs[table_ref].UpdateItemsWOField(
          { order_seq: mt.order_seq },
          mt,
          woFields
        )
      })
    },

    //保存派发
    async saveDispatch(cb) {
      let _this = this
      let _somain_current = this.$refs.saleOrderDispatch1.GetCurrentItem()
      if (this.$refs.saleOrderDispatch3.my_data.length == 0) {
        cb(true)
        return
      }
      if (this.isBusy_table3) {
        this.msgToasts(this.$t("notify.data_check_waiting"), "info")
        cb(true)
        return
      }
      let loading = null
      let dataLen = this.$refs.saleOrderDispatch3.my_data.length
      if (dataLen > 100) {
        loading = this.$loading({
          lock: true,
          text: this.$t("notify.waiting"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        this.$forceUpdate()
      }
      //检查数量
      let _qty_check_index = _.findIndex(
        this.$refs.saleOrderDispatch3.my_data,
        function (t) {
          return t.qty == 0 || t.qty == "" || _.isNull(t.qty)
        }
      )
      if (_qty_check_index > -1) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        cb(false)
        if (dataLen > 100) {
          loading.close()
        }
        return
      }
      //数据检测
      let _is_check_ok = await this.validData(
        this.$refs.saleOrderDispatch3.my_data
      )
      if (!_is_check_ok) {
        cb(true)
        if (dataLen > 100) {
          loading.close()
        }
        return
      }
      //检查供应商是否包含物料并提示
      let is_vi_check_ok = true
      let vend_not_invent = []
      _.each(this.$refs.saleOrderDispatch3.my_data, (t) => {
        if (!_.isNull(t._error) && t._error) {
          vend_not_invent.push(t)
        }
      })
      if (vend_not_invent.length > 0) {
        let vend_not_invent_list = _.groupBy(vend_not_invent, "AccountNum")
        let mlist = ""
        for (var t in vend_not_invent_list) {
          mlist += this.$t("common.provider") + "：" + t + this.$t("common.not_exist") + this.$t("common.invent") + "：" + _.join(_.uniq(_.map(vend_not_invent, "ItemId")), "，") + "；"
        }
        await this.msgModal(mlist + this.$t("notify.is_continue")).then((v) => {
          if (!v) {
            is_vi_check_ok = false
          }
        })
      }
      if (!is_vi_check_ok) {
        cb(false)
        if (dataLen > 100) {
          loading.close()
        }
        return
      }

      ///检查分配比例
      //物料已分配的供应商数量
      let error_dt = []
      let SalesLineIdList = _.map(this.$refs.saleOrderDispatch2.GetSelectedItems(), (t) => { return { SalesLineId: t.id } })
      let rt_detail_dis = await saleOrderDispatchAddController.methods.getSODetailDispatchedVendQty({ SalesLineIdJson: JSON.stringify(SalesLineIdList) })
      let _quotationType = "大货报价"
      if (_somain_current.SalesPoolId === "测试打样" || _somain_current.SalesPoolId === "样品销售") {
        _quotationType = "打样报价"
      }
      let pre_params = _.uniqWith(_.map(this.$refs.saleOrderDispatch3.my_data, (t) => { return { AccountNum: t.AccountNum, ItemId: t.ItemId, dataAreaId: _somain_current.dataAreaId, quotationType: _quotationType } }), _.isEqual)
      let rt_pre_dis = await saleOrderDispatchAddController.methods.getPreDistributionInDispatch(pre_params)
      if (rt_pre_dis && rt_pre_dis.length > 0) {
        let dt = []
        for (var i in rt_pre_dis) {
          dt = _.unionWith(dt, rt_pre_dis[i])
        }
        dt = _.uniqWith(dt, _.isEqual)

        let cdt = []
        _.each(this.$refs.saleOrderDispatch3.my_data, (m) => {
          ///此处排除派发供应商为内部公司的情况
          let _ex = _.findIndex(this.$store.state.biz_data.baseData.CompanyInfo, {
            VenderAccountNum: m.AccountNum,
          })
          console.log(_ex)
          let line_m = _.find(dt, { AccountNum: m.AccountNum, ItemId: m.ItemId })
          if (line_m) {
            let _m = _.cloneDeep(line_m)
            _m.qty = m.qty
            _m.SalesQty = m.SalesQty
            _m.SalesLineId = m.SalesLineId
            _m.DistributionRateChangedDes = m.DistributionRateChangedDes ? m.DistributionRateChangedDes : ""
            let _exm = _.find(cdt, { AccountNum: _m.AccountNum, ItemId: _m.ItemId, SalesLineId: _m.SalesLineId })
            if (_exm) {
              _exm.qty += _m.qty
              _exm.DistributionRateChangedDes += _m.DistributionRateChangedDes ? _m.DistributionRateChangedDes : ""
            }
            else
              cdt.push(_m)
          }
          else if (_ex < 0 && (!m.DistributionRateChangedDes || m.DistributionRateChangedDes == '')) error_dt.push(m.AccountNum)
        })
        _.each(cdt, (t) => {
          if (rt_detail_dis && rt_detail_dis.length > 0 && rt_detail_dis[0]) {
            let mt = _.find(rt_detail_dis[0], { SalesLineId: t.SalesLineId, AccountNum: t.AccountNum })
            if (mt) { t.qty += mt.qty }
          }
        })
        _.each(cdt, (t) => {
          let target_qty = t.DistributionRate / 100 * t.SalesQty
          ///此处排除派发供应商为内部公司的情况
          let _ex = _.findIndex(this.$store.state.biz_data.baseData.CompanyInfo, {
            VenderAccountNum: t.AccountNum,
          })
          if (t.qty > target_qty && t.DistributionRateChangedDes == "" && _ex < 0) error_dt.push(t.AccountNum)
        })
      }
      else {
        _.each(this.$refs.saleOrderDispatch3.my_data, (t) => {
          t.DistributionRateChangedDes = t.DistributionRateChangedDes ? t.DistributionRateChangedDes : ""
          ///此处排除派发供应商为内部公司的情况
          let _ex = _.findIndex(this.$store.state.biz_data.baseData.CompanyInfo, {
            VenderAccountNum: t.AccountNum,
          })
          if (t.DistributionRateChangedDes == "" && !_.includes(error_dt, t.AccountNum) && _ex < 0) error_dt.push(t.AccountNum)
        })
      }

      if (error_dt.length > 0) {
        this.msgToasts(_.join(error_dt, ",") + "供应商分配已变更，请输入变更原因！", "info")
        cb(false)
        return
      }

      //#region 执行数据保存
      ///整理数据
      let _list = []
      // let _update_soline_form_list = [];
      let data = _.cloneDeep(this.$refs.saleOrderDispatch3.my_data)
      let seq = 1
      _.each(data, (t) => {
        if (t.DistributionRateChangedDes && t.DistributionRateChangedDes != "") t.isDistributionRateChanged = true
        let _m = _.cloneDeep(saleOrderDispatchAddController.dataForm)
        for (var k in _m) {
          _m[k] = t[k]
        }
        if (t.delivery_date && _.isDate(t.delivery_date)) {
          _m.delivery_date = _this.$date.format(t.delivery_date, "yyyy-MM-dd")
        }
        //查找供应商公司编码
        let _company = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          VenderAccountNum: t.AccountNum,
        })

        if (_company) {
          _m.DataArea = _company.DataArea
        }

        _m.seq = seq
        _m.documentCreateByUsername = this.$global.global_data.local_username
        delete _m.order_seq
        delete _m.SalesPrice
        delete _m.price_currency
        _list.push(_m)
        seq += 1
      })
      let action_ids = []
      if (dataLen > 100) {
        loading.close()
      }
      if (_list.length > 100) {
        this.$refs.progressModal.show()
        this.$forceUpdate()
      }
      cb(false)

      let is_all_ok = false
      let step = 1
      for (var i in _list) {
        is_all_ok = false
        let items = []
        let _update_soline_form_list = []
        let vender_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { VenderAccountNum: _list[i].AccountNum })
        _list[i].is_internal = 0
        if (vender_m) {
          _list[i].is_internal = 1
        }

        _list[i].price = _list[i].price == "" ? 0 : _list[i].price
        _list[i].price_wotax = _list[i].price_wotax == "" ? 0 : _list[i].price_wotax
        _list[i].price_vend = _list[i].price_vend == "" ? 0 : _list[i].price_vend
        _list[i].price_vend_wotax = _list[i].price_vend_wotax == "" ? 0 : _list[i].price_vend_wotax
        _list[i].Cost_Sum = _list[i].Cost_Sum == "" ? 0 : _list[i].Cost_Sum

        if (_list[i].isNullPurchPrice) {
          _list[i].price = _list[i].price != 0 ? _list[i].price : 0
          _list[i].price_wotax = _list[i].price_wotax != 0 ? _list[i].price_wotax : 0
          _list[i].price_vend = _list[i].price_vend != 0 ? _list[i].price_vend : 0
          _list[i].price_vend_wotax = _list[i].price_vend_wotax != 0 ? _list[i].price_vend_wotax : 0
        }

        if (_.isNull(_list[i].price_vend)) {
          _list[i].price_vend = 0
        }
        // if (_.isNull(_list[i].price_vend_wotax)) {
        //   _list[i].price_vend_wotax = 0
        // }
        if (_.isNull(_list[i].Cost_Sum)) {
          _list[i].Cost_Sum = 0
        }

        items.push(_list[i])
        let _update_soline_form = {
          id: _list[i].SalesLineId,
        }
        let _index = _.findIndex(_update_soline_form_list, {
          id: _list[i].SalesLineId,
        })
        if (_index < 0) {
          _update_soline_form_list.push(_.cloneDeep(_update_soline_form))
        }
        let _rel_save_data = await saleOrderDispatchAddController.methods.saveDispatch(items, _update_soline_form_list, { id: _somain_current.id })
        if (!_.isNull(_rel_save_data)) {
          let _is_ok = false
          _.each(_rel_save_data, (t) => {
            if (!_.isNull(t.Result) && t.Result.Rollback) {
              _is_ok = t.Result.Rollback
            }
          })
          if (!_is_ok) {
            ///成功
            is_all_ok = true
            ///设置订单明细剩余数量
            let _rdata = _.filter(_rel_save_data, { Code: "data/e/update_sl_validremain" })

            _.each(_rdata, (t) => {
              let m = _.find(_this.$refs.saleOrderDispatch2.my_data, {
                id: t.Params[0].SalesLineId,
              })
              if (m && t.Result) {
                m.valid_approve = t.Result.Data[0][0].valid_approve
                m.valid_remain = t.Result.Data[0][0].valid_remain
              }
            })
            this.selectItem = null
            this.remoteVenderMethod()
            this.venders = []
          } else {
            ///剩余派单数量检查
            let is_qty_ok = true
            let check_list1 = _.filter(_rel_save_data, {
              Code: "data/e/sp_updateApproveStatus_PurchasePrice",
            })
            _.each(check_list1, (t) => {
              if (!_.isNull(t.Result) && t.Result.Rollback) {
                is_qty_ok = t.Result.Rollback
              }
            })
            if (!is_qty_ok) {
              this.msgToasts(this.$t("notify.pcs_not_more_valid_dispatched_pcs"), "error")
            }

            ///检查供应商是否包含物料
            let _is_order_isapproved = false
            let _is_vend_has_invent = false
            let _check_m = null
            let check_list2 = _.filter(_rel_save_data, {
              Code: "data/e/check_isExiste_vend_item",
            })
            _.each(check_list2, (t) => {
              if (!_.isNull(t.Result)) {
                if (t.Result.Rollback) {
                  _is_order_isapproved = t.Result.Rollback
                } else if (t.Result.Data && t.Result.Data.length > 0) {
                  _is_vend_has_invent = t.Result.Data[0][0].is_check_ok == 1
                  _check_m = t.Params[0]
                  let _vm = _.find(
                    this.$store.state.biz_data.baseData.CompanyInfo,
                    { DataArea: _check_m.dataAreaId }
                  )
                  if (_vm) {
                    _check_m.AccountNum = _vm.VenderAccountNum
                  }
                }
              }
            })
            if (_is_order_isapproved) {
              this.msgToasts(this.$t("notify.so_unapproved_not_dispatch"), "error")
            }
            if (_is_vend_has_invent) {
              this.msgToasts(this.$t("common.provider") + "（" + _check_m.AccountNum + "）" + this.$t("common.not_exist") + this.$t("common.invent") + "（" + _check_m.ItemId + "）！", "info")
            }

            ///检查能否派单
            let is_check_ok = true
            let check_list3 = _.filter(_rel_save_data, {
              Code: "data/i/sPlant_SalesOrder_Dispatch",
            })
            _.each(check_list3, (t) => {
              if (!_.isNull(t.Result) && t.Result.Rollback) {
                is_check_ok = false
              }
            })
            if (!is_check_ok) {
              this.msgToasts(this.$t("notify.dispatch_check_not_pass"), "error")
            }
            break
          }
          let rt = _.filter(_rel_save_data, {
            Code: "data/i/sPlant_SalesOrder_Dispatch",
          })
          _.each(rt, (t) => {
            action_ids.push(t.Result.Data[0][0].id)
          })
          step += 100 / _list.length
          if (_list.length > 100 && step >= 1) {
            this.$refs.progress.increase(1)
            step = 0
          }
        }
      }
      if (_list.length > 100) {
        this.$refs.progressModal.cancel()
      }
      if (is_all_ok) {
        await this.excuteDispatchedAction(_somain_current.SalesId, action_ids)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.$refs.saleOrderDispatch3.SetData([])
      }
      //#endregion
    },
    //数据检验
    async validData(data) {
      ////======检查正负数，以及价格
      let _line_current = this.$refs.saleOrderDispatch2.GetSelectedItems()
      let _is_check_return_ok = false
      let _is_qty_state_ok = true
      let _is_price_ok = true
      _.each(data, (t) => {
        t.qty = parseFloat(t.qty)
        let _m = _.find(_line_current, { id: t.SalesLineId })
        if (_m && _m.SalesQty < 0 && t.qty > 0) {
          _is_check_return_ok = true
        }
        if (_m && _m.SalesQty > 0 && t.qty < 0) {
          _is_qty_state_ok = false
        }

        ///只要不是自制，其他供应商都要检查实际价格是否为空
        let _self_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          DataArea: this.so_current_item.dataAreaId,
        })
        if (_self_m && _self_m.VenderAccountNum == t.AccountNum) {
        }
        else {
          let _inside_m = _.findIndex(
            this.$store.state.biz_data.baseData.CompanyInfo,
            { VenderAccountNum: t.AccountNum }
          )
          if (_inside_m > -1) {
            //内部
            if (_.isString(t.price) && !t.isNullPurchPrice) {
              _is_price_ok = false
            }
          }
          else {
            //外部
            if (_.isString(t.price) && !t.isNullPurchPrice) {
              _is_price_ok = false
            }
            console.log(t)
          }
        }
      })

      if (_is_check_return_ok == true) {
        this.msgToasts(this.$t("notify.sales_return_pcs_must_less_0"), "error")
        return false
      }
      if (!_is_qty_state_ok) {
        this.msgToasts(this.$t("notify.normal_so_can_not_minus_dispatch"), "error")
        return false
      }

      if (!_is_price_ok) {
        this.msgToasts(this.$t("notify.purch_price_not_null"), "error")
        return false
      }

      ////======检查是否全部选了供应商
      let _is_all_vend = false
      _.each(data, (t) => {
        if (_.isNull(t.AccountNum) || t.AccountNum == "") {
          _is_all_vend = true
        }
      })
      if (_is_all_vend == true) {
        this.msgToasts(this.$t("notify.select_provider"), "info")
        return false
      }

      ////======派单数量与剩余派单数量检查
      let _is_more_valid = false
      ///前端检查
      let _group_list_by_soline = _.groupBy(data, "SalesLineId")
      for (var i in _group_list_by_soline) {
        let _sl = _.find(this.$refs.saleOrderDispatch2.my_data, { id: Number(i) })
        if (_sl) {
          let sum_dispathch = _.sumBy(_group_list_by_soline[i], "qty")
          if (Math.abs(_sl.valid_remain) < Math.abs(sum_dispathch)) {
            _is_more_valid = true
          }
        }
      }
      if (_is_more_valid) {
        this.msgToasts(this.$t("notify.pcs_not_more_valid_dispatched_pcs"), "info")
        return false
      }
      return true
    },

    //#region ========保存后的审批相关操作
    async excuteDispatchedAction(SalesId, action_ids) {
      let _params = {}
      _params.SalesId = SalesId
      let _result = await saleOrderDispatchItemsController.methods.getData(
        _params
      )
      console.log(_result)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], (t) => {
          if (_.includes(action_ids, t.id)) {
            t.ApproveRemark = "同意"
            commonController.methods.getUserNameFromRole(
              this.all_role_users,
              t,
              "fcGetDocumentApprover",
              "Approver"
            )
            commonController.methods.getUserNameFromRole(
              this.all_role_users,
              t,
              "fcGetDocumentApprover",
              "Up_Approver"
            )
            return t
          }
        })
        if (dt.length > 0) {
          await this.excuteEmailAction(dt)
        }
      }
    },
    async excuteEmailAction(data) {
      let _somain_current = this.$refs.saleOrderDispatch1.GetCurrentItem()
      let action_ids = []
      let unApprovedList = _.filter(data, { fcCheckDocumentAllApproved: false })///审批检查未通过的集合
      let allApprovedList = _.filter(data, { fcCheckDocumentAllApproved: true })///审批检查通过的集合
      let update_approve_status_list = []//当审批人是派发人时，直接通过
      ///未通过则按规则发邮件给下一级审批人
      if (unApprovedList.length > 0) {
        let splitCurApproverData = []
        _.each(unApprovedList, (t) => {
          let spApproverList = t.Approver.split("，")
          for (var s in spApproverList) {
            let tempt = _.cloneDeep(t)
            tempt.current_approver = spApproverList[s]
            splitCurApproverData.push(tempt)
          }
        })
        let group_approver = _.groupBy(_.uniq(splitCurApproverData), "current_approver")
        ///发送邮件
        let notify_list = []
        let content_list = []
        for (var g in group_approver) {
          let _gt = group_approver[g]
          if (g == this.$global.global_data.local_username) {
            for (var k in _gt) {
              action_ids.push(_gt[k].id)
              update_approve_status_list.push(_gt[k])
            }
            continue
          }
          for (var d in _gt) {
            let dm = _.cloneDeep(_gt[d])
            let profitRate = 0, initialProfitRate = 0//毛利,初始毛利
            dm.price_wotax = dm.price_wotax === "" ? 0 : dm.price_wotax
            dm.price_vend_wotax = dm.price_vend_wotax === "" ? 0 : dm.price_vend_wotax
            profitRate = dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_wotax) * 100 / dm.Sales_Order_Price, 2) //订单价格-实际采购价/订单价格
            initialProfitRate = dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_vend_wotax) * 100 / dm.Sales_Order_Price, 2) //订单价格-初始采购价/订单价格
            let so_item_m = _.find(this.$refs.saleOrderDispatch2.my_data, { id: dm.SalesLineId })
            let content_list_m = {
              UserName: dm.create_by_username,
              SendDate: this.formatDate(dm.create_at, "yyyy-MM-dd HH:mm:ss"),
              ItemId: dm.ItemId,
              NameAlias: dm.NameAlias,
              VendAccountName: dm.SEI_Name,
              InitialVendPrice: _.round(dm.price_vend_wotax, 2),//初始本币净单价
              VendPrice: _.round(dm.price_wotax, 2),//实际本币净单价
              Sales_Order_Price: _.round(dm.Sales_Order_Price, 2),//实际销售价
              ProfitRate: profitRate,
              InitialProfitRate: initialProfitRate,
              Qty: dm.qty, //派发数量
              Amount: _.round(_.round(dm.price_wotax, 2) * dm.qty, 2), //派发金额
              Remark: so_item_m ? so_item_m.TEC_CommonRemark : "", //通用备注
              PriceRemark: dm.price_remark,
              DistributionRateChangedDes: dm.DistributionRateChangedDes
            }
            content_list.push(content_list_m)
          }

          let email_data = {
            main: {
              Title: "",
              Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
              Url_Name: window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
              UserName: _gt[0].create_by_username,
              SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
            },
            list: content_list
          }
          let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change", email_data, g)

          let lang_code = notify_template.methods.getUserLangCode(this, g)
          let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

          let _send_to = {}
          _send_to[g] = ""
          let _notify_p = {
            category: "SalesOrderDispatch",
            idx: "",
            itemId: 0,
            notify_type: "SalesOrderDispatch",
            subject: _gt[0].SalesId + email_template["sod_wait_approve_be_care"],
            content: email_content,
            SendTo: _send_to
          }
          notify_list.push(_notify_p)
        }
        ///发送邮件
        if (notify_list.length > 0) {
          let _rsult = await commonController.methods.sendOrCancelNotify(
            "add",
            notify_list
          )

          if (!_.isNull(_rsult)) {
            console.log(this.$t("notify.email_seccess"))
          }
        }
        if (update_approve_status_list.length > 0) {
          let _params_list = []
          let _p = {}
          _p.approve_data = await this.getUpdateApproveStatusParams(update_approve_status_list, true)
          _params_list.push(_p)
          await SaleOrderDispatchSearchController.methods.approveListData(_params_list)
          if (action_ids.length > 0) {
            await this.excuteDispatchedAction(_somain_current.SalesId, action_ids)
          }
        }
      }
      ///通过则调用AX接口
      if (allApprovedList.length > 0) {
        let loading = this.$loading({
          lock: true,
          text: this.$t("notify.waiting_data_interaction"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        ///整理接口数据
        let res_msg = [], ax_error_venders = [], res_venders_msg_list = []
        let group_vend_list = _.cloneDeep(_.groupBy(allApprovedList, "AccountNum"))
        for (var j in group_vend_list) {
          let _params_list = []
          let _list = _.cloneDeep(group_vend_list[j])
          let _p = {}
          ///1、审批数据
          _p.approve_data = await this.getUpdateApproveStatusParams(_list, true)
          ///2、订单明细剩余数量参数
          _p.update_valid_data = []
          _.each(_list, (l) => {
            let _index = _.findIndex(_p.update_valid_data, { id: l.SalesLineId })
            if (_index < 0) {
              _p.update_valid_data.push({ id: l.SalesLineId })
            }
          })

          ///3、AX接口
          _p.ax_data = this.getAXParams(_list, "", "Approve")
          ///4、采购参数
          _p.purch_data = this.getCreatePurchaseParams(_list, data.state)
          _p.state = true
          _params_list.push(_p)

          let result = await SaleOrderDispatchSearchController.methods.approveListData(_params_list)
          if (!_.isNull(result)) {
            if (!result.state) {
              let _venders = _.map(_list, "AccountNum")
              ax_error_venders.push(_venders[0])
              res_msg.push("<hr/><div>" + this.$t("common.provider") + this.$t("common.num") + "：" + _venders[0] + "，" + result.message + "</div>")
              res_venders_msg_list.push({
                vender: _venders[0],
                msg: result.message
              })
            }
          }
        }
        if (res_msg.length > 0) {
          this.msgToasts(this.$t("notify.ax_error") + "：" + _.join(res_msg, " "), "info", null, true)
          console.log(ax_error_venders)
          ///如果ax接口调用失败，则将审批状态修改为未审批状态
          if (ax_error_venders.length > 0) {
            let _params = [], ax_exception_list = []
            for (var i in ax_error_venders) {
              let dispatch_list = group_vend_list[ax_error_venders[i]]
              _.each(dispatch_list, (t) => {
                let m = _.find(res_venders_msg_list, { vender: ax_error_venders[i] })
                if (m) {
                  _params.push({
                    isAXError: true,
                    AXError: m.msg,
                    id: t.id
                  })
                  let exc_t = _.cloneDeep(t)
                  exc_t.isAXError = true
                  exc_t.AXError = m.msg
                  ax_exception_list.push(exc_t)
                }
              })
            }
            if (_params.length > 0) {
              await saleOrderDispatchAddController.methods.updateSODAxState(_params)
              await this.SendEmail(ax_exception_list)//发邮件给创建人，异常邮件通知人以及异常处理人
            }
          }
        }
        else {
          ///成功后发邮件
          await this.sendEmailAfterApproved(allApprovedList)
        }
        loading.close()
      }
    },
    ///获取审批参数
    async getUpdateApproveStatusParams(_list, _state) {
      let _update_status_list = []
      let _roles = []
      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      for (var i in _list) {
        _list[i].is_approved = _state
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesOrderDispatch",
          ApproveType: "",
          ItemId: _list[i].id,
        })
        _.each(_as_result[0], (at) => {
          if (at) {
            if (_state) {
              if (
                _.includes(_roles, at.Approver) ||
                this.$global.global_data.local_username == at.Approver
              ) {
                at.is_approved = _state
                at.username = this.$global.global_data.local_username
                at.order_dispatch_id = _list[i].id
                at.userId = this.$store.state.biz_data.userInfo.user_id
                at.ApproveRemark = "同意" //审批备注
                at.price = _list[i].price
                at.price_vend = _list[i].price_vend
                at.Sales_Order_Price = _list[i].Sales_Order_Price
                at.Sales_Doc_Price = _list[i].Sales_Doc_Price
                _update_status_list.push(at)
              }
            }
          }
        })
      }
      return _update_status_list
    },
    ///整理ax参数
    getAXParams(_list, _Status, _ApproveStatus) {
      let _this = this
      ///整理jsonData
      let _jsonData = [], sd_create_by_username = ""
      let so_m = this.$refs.saleOrderDispatch1.GetCurrentItem()
      if (so_m) {
        sd_create_by_username = so_m.create_by_username
      }
      let _soline_current = _list[0]
      for (var i in _list) {
        let t = _list[i]
        if (_ApproveStatus == "Approve" && !t.fcCheckDocumentAllApproved) {
          continue
        }
        let _self_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          DataArea: t.dataAreaId,
        })
        let _temp_Status = _Status
        let _AccountNum = t.AccountNum
        let _vendTaxGroup = t.VendTaxGroup ///供应商税组
        if (_vendTaxGroup == "") {
          let _vend = _.find(this.$store.state.biz_data.baseData.Vender, {
            AccountNum: t.AccountNum,
          })
          if (_vend) {
            _vendTaxGroup = _vend.TaxGroup
          }
        }
        if (_self_m && _self_m.VenderAccountNum == t.AccountNum) {
          _AccountNum = ""
        }
        if (_Status == "") {
          if (!_.isNull(t.AXSalesId) && t.AXSalesId != "") {
            _temp_Status = "Update"
          } else {
            _temp_Status = "Create"
          }
        }
        if (t.delivery_date && _.isDate(t.delivery_date)) {
          t.delivery_date = _this.$date.format(t.delivery_date, "yyyy-MM-dd")
        }
        let _purch_code = t.CurrencyCode
        if (t.PurchCurrencyCode && !_.isNull(t.PurchCurrencyCode)) {
          _purch_code = t.PurchCurrencyCode
        }
        let _AXInventTransRet = ""
        let _AXPurchInventTransRet = ""
        if (parseFloat(t.SalesQty) < 0) {
          _AXInventTransRet = t.AXInventTransRet
          _AXPurchInventTransRet = t.AXInventTransRet
        }

        _jsonData.push({
          SalesId: t.SalesLineId,
          CustAccount: t.CustAccount,
          DeliveryDate: _this.formatDate(t.ConfirmedDlv),
          TaxGroup: t.TaxGroup,
          SalesPoolId: t.SalesPoolId,
          InclTax: t.InclTax == "是" ? 1 : 0,
          TEC_Remark: t.TEC_Remark,
          TEC_FinalCustAccount: t.TEC_FinalCustAccount,
          LineNum: t.id,
          ItemId: t.ItemId,
          RetailVariantId: t.RetailVariantId,
          SalesPrice: t.SalesPrice,
          CurrencyCode: t.CurrencyCode,
          ConfirmedDlv: _this.formatDate(t.delivery_date),
          SalesUnit: _.isEmpty(t.DW_InventUnitId) == true ? "个" : t.DW_InventUnitId,
          SalesQty: t.qty,
          TEC_CommonRemark: t.TEC_CommonRemark,
          TEC_CustSalesID: t.TEC_CustSalesID,
          TEC_LineAmountBak: "",
          SEI_OrderDateCust: _this.formatDate(t.SEI_OrderDateCust),
          SEI_PriceUnitCust: t.SEI_PriceUnitCust,
          SEI_ShippingDateCust: _this.formatDate(t.SEI_ShippingDateCust),
          // "dataAreaId": "070",
          VendAccount: _AccountNum,
          VendTaxGroup: _vendTaxGroup,
          AXInventTransRet: _AXInventTransRet,
          AXPurchInventTransRet: _AXPurchInventTransRet,
          SalesNO: t.SalesId, ///订单编号
          CreateBy: sd_create_by_username,
          PurchPrice: t.price,
          PurchCurrencyCode: _purch_code,
          PurchDeliveryDate: _this.formatDate(t.delivery_date),
          PurchUnit: _.isEmpty(t.DW_InventUnitId) == true ? "个" : t.DW_InventUnitId,
          Status: _temp_Status,
          AXSalesId: t.AXSalesId,
          AXInventTransId: t.AXInventTransId,
          AXPurchId: t.AXPurchId,
          AXPurchInventTransId: t.AXPurchInventTransId,
          AXSalesLineNum: _.isNull(t.AXSalesLineNum) ? "" : t.AXSalesLineNum,
          AXPurchLineNum: _.isNull(t.AXPurchLineNum) ? "" : t.AXPurchLineNum,
          ApproveStatus: _ApproveStatus,
          InventLocationId: t.DW_inventBatchIdSales,
          DeliveryAddress: t.DeliveryAddress //订单明细送货地址
        })
      }
      let _group_data = _.groupBy(_jsonData, "VendAccount")
      return {
        company: _soline_current.dataAreaId,
        jsonGroupData: _group_data,
      }
    },
    ///获取采购单参数
    getCreatePurchaseParams(data) {
      let result = { main: [], items: [], update_list: [] }
      let _create_list = []
      ///仅初次审核才创建采购单
      _.each(data, (t) => {
        if (_.isEmpty(t.AXSalesId) || _.isNull(t.AXSalesId)) {
          _create_list.push(t)
        }
      })
      if (_create_list.length > 0) {
        let _group_list = _.groupBy(_create_list, "AccountNum")
        let order_master_list = []
        let order_item_list = []
        for (var i in _group_list) {
          let masterForm = {
            id: "",
            PurchId: "",
            OrderAccount: _group_list[i][0].AccountNum, //供应商账户
            OrderAccountName: _group_list[i][0].SEI_Name, //供应商名称
            CurrencyCode: _group_list[i][0].CurrencyCode,
            InclTax: _group_list[i][0].InclTax,
            dataAreaId: _group_list[i][0].dataAreaId, //公司
            AX_PurchId: "", //AX采购单编号
            AX_SalesOrderId: "", //AX销售单编号
          }
          order_master_list.push(masterForm)

          let _num = 1
          ///添加items
          for (var j in _group_list[i]) {
            let itemForm = {
              id: "",
              PurchaseOrderId: "",
              LineNumber: _num,
              ItemId: _group_list[i][j].ItemId,
              NameAlias: _group_list[i][j].NameAlias,
              PurchQty: _group_list[i][j].qty, //数量
              PurchPrice: _group_list[i][j].price,
              PurchUnit: _.isNull(_group_list[i][0]) ? "" : _group_list[i][0].SalesUnit,
              LineAmount: _group_list[i][j].qty * _group_list[i][j].price,
              dataAreaId: _group_list[i][0].dataAreaId, //公司
              RetailVariantId: _group_list[i][j].RetailVariantId,
              VariantName: _group_list[i][j].VariantName,
              DeliveryDate: _group_list[i][j].delivery_date,
              OrderDispatch_id: _group_list[i][j].id, //派单id
              AX_Line_PurchId: "", //AX采购单行编号
              AX_Line_SalesOrderId: "", //AX销售单行编号
              OrderAccount: _group_list[i][0].AccountNum,
            }
            order_item_list.push(itemForm)
            _num += 1
          }
        }

        result.main = order_master_list
        result.items = order_item_list
      }

      return result
    },
    ///审批后发邮件
    async sendEmailAfterApproved(data) {
      let _p = {
        notify_type: "sod_approve_pass",
        subject: "sod_approve_pass",
        idx: "id"
      }
      let _groupby_user = _.groupBy(data, "create_by_username")
      ///发邮件给派发人
      await this.exSendEmailAfterApproved(_groupby_user, _p, "vend")
      ///发邮件给订单创建人
      await this.exSendEmailAfterApproved(_.groupBy(data, "sd_create_by_username"), _p)
      ///根据派发人发送邮件
      let list = []
      for (var i in data) {
        let _m = _.cloneDeep(data[i])
        let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: _m.AccountNum,
        })
        if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
          //邮件通知人
          let _dt = _.split(vend.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p, "vend")
      }
    },
    async exSendEmailAfterApproved(_groupby_user, _p, type, is_refused) {
      let notify_list = []
      for (var d in _groupby_user) {
        let lang_code = notify_template.methods.getUserLangCode(this, d)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _email_params = {
          notify_type: _p.notify_type,
          subject: email_template[_p.subject],
          create_by_username: d,
          list: _groupby_user[d],
          idx: _p.idx,
        }
        let _ep =
          notify_template.methods.getApprovedEmailTemplate(_email_params, this, type, is_refused)
        notify_list.push(_ep)
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify("add", notify_list)
      }
    },
    async SendEmail(data) {
      ///发送邮件
      let exception_list = [], notify_list = []
      for (var d in data) {
        let dm = _.cloneDeep(data[d])
        dm.price_wotax == "" ? 0 : dm.price_wotax
        dm.price_vend_wotax == "" ? 0 : dm.price_vend_wotax
        let so_item_m = _.find(this.$refs.saleOrderDispatch2.my_data, { id: dm.SalesLineId })
        let content_list_m = {
          UserName: dm.create_by_username,
          SendDate: this.formatDate(dm.create_at, "yyyy-MM-dd HH:mm:ss"),
          ItemId: dm.ItemId,
          NameAlias: dm.NameAlias,
          VendAccountName: dm.SEI_Name,
          InitialVendPrice: _.round(dm.price_vend_wotax, 2),
          VendPrice: _.round(dm.price_wotax, 2),
          ProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_wotax) * 100 / dm.Sales_Order_Price, 2), //(订单价格-实际采购价)/订单价格
          InitialProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_vend_wotax) * 100 / dm.Sales_Order_Price, 2), //(订单价格-初始采购价)/订单价格
          Qty: dm.qty, //派发数量
          Amount: _.round(dm.price_wotax * dm.qty, 2), //派发金额
          isAXError: "异常",
          AXError: dm.AXError,
          Remark: so_item_m ? so_item_m.TEC_CommonRemark : "", //通用备注
          PriceRemark: dm.price_remark, //实际采购价备注
        }
        ///出现异常则不发邮件给供应商通知人以及派发创建人
        if (dm.isAXError) {
          exception_list.push(content_list_m)
        }
      }
      ///如果出现异常则发邮件给异常处理人
      if (exception_list.length > 0) {
        let _profit_m = _.find(
          this.$store.state.biz_data.baseData.SystemSetting,
          { code: "email_notifier" }
        )
        if (_profit_m && _profit_m.setting_value != "") {
          let m = JSON.parse(_profit_m.setting_value)
          if (m.dispatchErrorEmailNotifier && m.dispatchErrorEmailNotifier.length > 0) {
            let eusers = []
            let roles = _.map(
              this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
              "code"
            )
            for (var i in m.dispatchErrorEmailNotifier) {
              if (_.includes(roles, m.dispatchErrorEmailNotifier[i])) {
                let _result = await RoleManageController.methods.GetRoleUsers(-1, m.dispatchErrorEmailNotifier[i])
                _result = _.filter(_result, { is_sys: false })
                if (_result && _result.length > 0) {
                  _.each(_result, (t) => {
                    eusers.push(t)
                  })
                }
              }
              else {
                eusers.push(m.dispatchErrorEmailNotifier[i])
              }
            }
            eusers.push(this.$global.global_data.local_username)
            eusers = _.uniq(eusers)//去除重复项
            console.log(eusers)
            _.each(eusers, (tm) => {
              let lang_code = notify_template.methods.getUserLangCode(this, tm)
              let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

              let email_data = {
                main: {
                  Title: "",
                  Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch",
                  Url_Name: window.location.host + "/sd/saleOrderDispatch",
                  UserName: this.$global.global_data.local_username,
                  SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
                },
                list: exception_list
              }
              let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change_exception", email_data, tm)

              let _send_to = {}
              _send_to[tm] = ""
              let _notify_p = {
                category: "SalesOrderDispatch",
                idx: "",
                itemId: 0,
                notify_type: "SalesOrderDispatch",
                subject: email_template["sod_ax_error_handing"],
                content: email_content,
                SendTo: _send_to
              }
              notify_list.push(_notify_p)
            })
          }
        }
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify(
          "add",
          notify_list
        )
      }
    },
    //#endregion

    ///数量改变
    async saleOrderDispatch3_on_input(data) {
      if (data.field.key == "Capacity") {
        return
      }
      if (data.field.key == "qty") {
        data.item.price = 0
        await this.setDisDataStateAndInfo(
          "saleOrderDispatch3",
          ["Capacity", "delivery_date", "invent_sum"],
          data.item
        )
      }
    },
    async saleOrderDispatch3_on_change(data) {
      if (data.field.key == "delivery_date") {
        await this.setDisDataStateAndInfo(
          "saleOrderDispatch3",
          ["qty", "price", "delivery_date", "invent_sum"],
          data.item
        )
      }
    },

    async table3_state_change(data, cb) {
      if (data.state === "deleted")
        this.$refs.saleOrderDispatch3.RemoveItems(data.selected_items)
    },
    async only_main_methods(only_value) {
      this.$refs.saleOrderDispatch2.SetData([])
      this.$refs.saleOrderDispatch3.SetData([])
      this.$refs.saleOrderDispatch2.only_value = false
      //筛选未完成的
      let _dt = _.filter(_.cloneDeep(this.soHisData), (t) => {
        if (!t.fcCheckIsSalesOderAllDispatched) {
          return t
        }
      })
      if (!only_value) {
        this.$refs.saleOrderDispatch1.SetData(_dt)
      }
      else {
        this.$refs.saleOrderDispatch1.SetData(_.cloneDeep(this.soHisData))
      }

    },
    only_methods(only_value) {
      this.remoteVendPriceMethod(this.vend_price_state, false)
      // await this.getItems(only_value);
    },
    setVendOptionsData(dropdownSearchValue, item) {
      let only_item_selected = []
      if (this.isAllVender) {
        only_item_selected = _.cloneDeep(this.$store.state.biz_data.baseData.Vender)
        let all_vender = _.filter(this.$store.state.biz_data.baseData.AllVender, (t) => {
          if (t.Blocked == "否" && t.dataAreaId == this.so_current_item.dataAreaId) {
            return t
          }
        })
        only_item_selected = _.filter(only_item_selected, (t) => {
          let _index = _.findIndex(all_vender, (m) => {
            return m.AccountNum == t.AccountNum
          })
          if (_index > -1) {
            return t
          }
        })
      }
      else {
        let so_current = this.$refs.saleOrderDispatch1.GetCurrentItem()
        only_item_selected = _.filter(this.vender_his_options, (t) => {
          if (t.itemId == "") {
            return t
          }
          else if (so_current.fcCheckIfSOItemHasVendPrice && t.itemId == item.ItemId && t.is_only_initial == 0) {
            return t
          }
        })
      }
      only_item_selected = _.map(only_item_selected, (t) => {
        return {
          AccountNum: t.AccountNum,
          SEI_Name: t.SEI_Name
        }
      })

      let _list = only_item_selected
      if (dropdownSearchValue && dropdownSearchValue != "") {
        ///编号只能是等于
        _list = _.filter(only_item_selected, function (t) {
          if (_.includes(t.AccountNum, dropdownSearchValue) || _.includes(t.SEI_Name, dropdownSearchValue)) {
            return t
          }
        })
      }
      // console.log(_list)
      item.items = _.map(_list, (t) => {
        return {
          value: t.AccountNum,
          label: t.AccountNum + "：" + t.SEI_Name,
        }
      })//_list.splice(0, 10);
    },
    setTaxGroupData(dropdownSearchValue) {
      let _list = []
      console.log(this.so_current_item)
      if (!this.so_current_item) {
        return _list
      }
      let taxGroupList = _.filter(
        this.$store.state.biz_data.baseData.TaxGroupHeading,
        { dataAreaId: this.so_current_item.dataAreaId }
      )
      let taxgroup_options = taxGroupList //_.uniqBy(this.$store.state.biz_data.baseData.TaxGroupHeading, "TaxGroup")
      if (taxgroup_options.length > 0) {
        _.each(taxgroup_options, (t) => {
          let _index = _.findIndex(_list, { TaxGroup: t.TaxGroup })
          if (_index < 0) {
            _list.push({
              TaxGroup: t.TaxGroup,
              TaxGroupName: t.TaxGroup + ":" + t.TaxGroupName,
            })
          }
        })
      }

      return _list
    },
    ///弹出供应商选择
    async item_drop_click(data) {
      this.modal_vend_price_state = "vend_price"
      this.current_dispatch_line = data.item
      this.modal_title = this.$t("common.invent") + "（" + data.item.ItemId + "：" + data.item.NameAlias + "）"
      this.$refs.bvModal.show()

      // this.isBusy_VendQuoteTable = true;
      let quoted_vend_list = await saleOrderDispatchAddController.methods.getHasQuoteVends({
        ItemId: data.item.ItemId,
        currency: data.item.PurchCurrencyCode
      })

      if (quoted_vend_list && quoted_vend_list[0] &&
        quoted_vend_list[0].Result.Data &&
        quoted_vend_list[0].Result.Data.length > 0 &&
        quoted_vend_list[0].Result.Data[0]) {
        let rt = quoted_vend_list[0].Result.Data[0]
        let _dt = this.setVendQuoteData(data, rt)
        this.has_quote_vend_list_his = _.cloneDeep(_dt)
        ///这里做了有实际报价和仅有初始报价筛选
        _dt = _.cloneDeep(_.filter(_dt, { is_only_initial: this.modal_vend_price_state == "vend_price" ? 0 : 1 }))
        this.$refs.VendQuoteTable.SetData(_dt)
        console.log(this.$refs.VendQuoteTable.my_data)
      }
      await this.setDisDataStateAndInfo("VendQuoteTable")
      // this.isBusy_VendQuoteTable = false;

      // this.$forceUpdate();
      // setTimeout(async () => {
      //   this.$refs.VendQuoteTable.SetData(this.has_quote_vend_list_his);
      //   setTimeout(async () => {
      //     for (var i in this.$refs.VendQuoteTable.my_data) {
      //       await this.setDisDataStateAndInfo(
      //         "VendQuoteTable",
      //         ["Capacity", "delivery_date", "invent_sum"],
      //         this.$refs.VendQuoteTable.my_data[i]
      //       );
      //     }
      //     let _order_list = _.cloneDeep(_.filter(this.$refs.VendQuoteTable.my_data, { is_only_initial: this.modal_vend_price_state == "vend_price" ? 0 : 1 }));
      //     this.$refs.VendQuoteTable.SetData(
      //       _.orderBy(_order_list, ["price"], ["asc"])
      //     );
      //     this.isBusy_VendQuoteTable = false;
      //   }, 200);
      // }, 500);
    },
    setVendQuoteData(data, list) {
      let _list = []
      let _order_seq = 0
      let so_m = this.$refs.saleOrderDispatch1.GetCurrentItem()
      console.log(list)
      for (var i in list) {
        let pt = list[i]
        let t = _.cloneDeep(data.item)
        let _index = _.findIndex(_list, { AccountNum: pt.AccountNum })
        let is_add = false
        // so_m.fcCheckIfSOItemHasVendPrice &&
        if (_index < 0) {
          if (so_m.SalesPoolId === "测试打样" || so_m.SalesPoolId === "样品销售") {
            if (pt.quotationType === "打样报价")
              is_add = true
          }
          else if (pt.quotationType !== "打样报价")
            is_add = true
        }
        console.log(is_add)
        if (is_add) {
          t._rowVariant = ""
          t._selected = false
          t._current = false
          t.order_seq = _order_seq
          t.AccountNum = pt.AccountNum
          t.SEI_Name = pt.SEI_Name
          t._error = false
          t.is_only_initial = pt.is_only_initial//是否初始报价
          t.quotationType = pt.quotationType
          ///供应商相关信息
          let vend_m = _.find(this.$store.state.biz_data.baseData.Vender, {
            AccountNum: pt.AccountNum,
          })
          if (vend_m) {
            t.TotalScore = vend_m.TotalScore
          }
          let item_vend_m = _.find(this.$store.state.biz_data.baseData.AllVender,
            {
              AccountNum: pt.AccountNum,
              dataAreaId: so_m.dataAreaId,
            }
          )
          if (item_vend_m) {
            t.TaxGroup = item_vend_m.TaxGroup
          }
          _order_seq += 1
          _list.push(_.cloneDeep(t))
        }
      }

      let vender_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { DataArea: so_m.dataAreaId })
      if (vender_m) {
        let t = _.cloneDeep(data.item)
        t._rowVariant = ""
        t._selected = false
        t._current = false
        t.order_seq = _order_seq + 1
        t.AccountNum = vender_m.VenderAccountNum
        t.SEI_Name = vender_m.CompanyName
        t._error = false
        t.is_only_initial = 0//是否初始报价
        t.quotationType = "大货报价"
        ///供应商相关信息
        let vend_m = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: vender_m.VenderAccountNum,
        })
        if (vend_m) {
          t.TotalScore = vend_m.TotalScore
        }
        let item_vend_m = _.find(this.$store.state.biz_data.baseData.AllVender,
          {
            AccountNum: vender_m.VenderAccountNum,
            dataAreaId: so_m.dataAreaId,
          }
        )
        if (item_vend_m) {
          t.TaxGroup = item_vend_m.TaxGroup
        }
        let _index = _.findIndex(_list, { AccountNum: t.AccountNum })
        if (_index < 0) {
          _list.unshift(t)
        }
      }
      console.log(_list)
      return _list
    },
    async choseVendData(cb) {
      if (!_.isNull(this.current_dispatch_line)) {
        let _select_list = this.$refs.VendQuoteTable.GetSelectedItems()
        if (_select_list && _select_list.length > 0) {
          this.current_dispatch_line.AccountNum = _select_list[0].AccountNum
          this.current_dispatch_line.SEI_Name = _select_list[0].SEI_Name
          this.current_dispatch_line.qty = _select_list[0].qty
          this.current_dispatch_line.price = _select_list[0].price
          this.current_dispatch_line.price_vend = _select_list[0].price_vend
          this.current_dispatch_line.price_vend_wotax = _select_list[0].price_vend_wotax
          this.current_dispatch_line.price_vend_currency = _select_list[0].price_vend_currency
          this.current_dispatch_line.Cost_Sum = _select_list[0].Cost_Sum
          this.current_dispatch_line.delivery_date =
            _select_list[0].delivery_date
          this.current_dispatch_line.profit_state =
            _select_list[0].profit_state
          this.current_dispatch_line.profit_value =
            _select_list[0].profit_value
          this.current_dispatch_line.Capacity = _select_list[0].Capacity
          this.current_dispatch_line.TotalScore = _select_list[0].TotalScore
          this.current_dispatch_line.PurchCurrencyCode =
            _select_list[0].PurchCurrencyCode
          this.current_dispatch_line.TaxGroup = _select_list[0].TaxGroup //供应商税组
          this.current_dispatch_line.price_tax = _select_list[0].price_tax
          this.current_dispatch_line.price_wotax = _select_list[0].price_wotax
          this.current_dispatch_line._error = _select_list[0]._error
          this.current_dispatch_line.invent_sum = _select_list[0].invent_sum
          this.current_dispatch_line.PreDistributRate = ""
          ///显示预分配比例
          let _somain_current = this.$refs.saleOrderDispatch1.GetCurrentItem()
          let _quotationType = "大货报价"
          if (_somain_current.SalesPoolId === "测试打样" || _somain_current.SalesPoolId === "样品销售") {
            _quotationType = "打样报价"
          }
          let pre_params = _.map(this.$refs.saleOrderDispatch3.my_data, (t) => { return { AccountNum: t.AccountNum, ItemId: t.ItemId, dataAreaId: _somain_current.dataAreaId, quotationType: _quotationType } })
          pre_params = _.uniqWith(pre_params, _.isEqual)
          let rt_pre_dis = await saleOrderDispatchAddController.methods.getPreDistributionInDispatch(pre_params)
          if (rt_pre_dis && rt_pre_dis.length > 0) {
            for (var k in rt_pre_dis) {
              if (rt_pre_dis[k][0]) {
                let drlist = _.filter(this.$refs.saleOrderDispatch3.my_data, { AccountNum: rt_pre_dis[k][0].AccountNum, ItemId: rt_pre_dis[k][0].ItemId })
                if (drlist && drlist.length > 0) {
                  _.each(drlist, (mt) => {
                    mt.PreDistributRate = rt_pre_dis[k][0].DistributionRate
                  })
                }
              }
            }
          }
        } else {
          this.msgToasts(this.$t("notify.select_provider"), "info")
          cb(null)
          return
        }
      }
      cb(false)
      this.$refs.bvModal.cancel()
    },

    async VendQuoteTable_on_input(data) {
      if (data.field.key == "Capacity") {
        return
      }
      if (data.field.key == "qty") {
        data.item.price = 0
        this.setDisDataStateAndInfo(
          "VendQuoteTable",
          ["Capacity", "delivery_date", "invent_sum"],
          data.item
        )
      }
    },
    async VendQuoteTable_on_change(data) {
      if (data.field.key == "delivery_date") {
        this.setDisDataStateAndInfo(
          "VendQuoteTable",
          ["qty", "price", "delivery_date", "invent_sum"],
          data.item
        )
      }
    },
    item_select_change(item) {
      this.$refs.VendQuoteTable.UnSelectAll()
      let _m = _.cloneDeep(item)
      let _item_list = []
      _item_list.push(_m)
      this.$refs.VendQuoteTable.setItemSelect(_item_list, true)
    },
    async item_drop_commond(commond) {
      let _this = this
      let so_m = this.$refs.saleOrderDispatch1.GetCurrentItem()
      if (commond) {
        ///设置值
        let _id = _.split(commond, "#", 2)[1]
        let _m = _.find(this.$refs.saleOrderDispatch3.my_data, {
          _id: parseInt(_id),
        })
        if (_m) {
          let _accountNum = _.split(commond, "#", 2)[0]
          ///供应商相关信息
          let vend_m = _.find(_this.$store.state.biz_data.baseData.Vender, { AccountNum: _accountNum })
          if (vend_m) {
            _m.AccountNum = vend_m.AccountNum
            _m.SEI_Name = vend_m.SEI_Name
            _m.TotalScore = vend_m.TotalScore
            _m.PurchCurrencyCode = vend_m.Currency
          }
          else {
            _m.PurchCurrencyCode = 'CNY'
          }
          let item_vend_m = _.find(_this.$store.state.biz_data.baseData.AllVender,
            {
              AccountNum: _accountNum,
              dataAreaId: so_m.dataAreaId,
            }
          )
          if (item_vend_m) {
            _m.TaxGroup = item_vend_m.TaxGroup
          }
          _m.price = 0
          _m.price_tax = 0
          _m.price_wotax = 0
          _m.Capacity = 0
          _m.Cost_Sum = 0
          _m._error = false
          await this.setDisDataStateAndInfo("saleOrderDispatch3", [], _m)
          ///显示预分配比例
          _m.PreDistributRate = ""
          let _quotationType = "大货报价"
          if (so_m.SalesPoolId === "测试打样" || so_m.SalesPoolId === "样品销售") {
            _quotationType = "打样报价"
          }
          let pre_params = { AccountNum: _m.AccountNum, ItemId: _m.ItemId, dataAreaId: so_m.dataAreaId, quotationType: _quotationType }
          let rt_pre_dis = await saleOrderDispatchAddController.methods.getPreDistributionInDispatch(pre_params)
          if (rt_pre_dis && rt_pre_dis.length > 0) {
            for (var k in rt_pre_dis) {
              if (rt_pre_dis[k][0]) {
                _m.PreDistributRate = rt_pre_dis[k][0].DistributionRate
              }
            }
          }
        }
      }
    },
    ///检查供应商是否包含物料(内部供应商才检查)
    checkIsInventInVender() {
      _.each(this.$refs.saleOrderDispatch3.my_data, async (t) => {
        t._error = false
        this.$refs.saleOrderDispatch3.updateRowBackgroundColor(t)

        let _companyid = 0
        if (!_.isNull(t.AccountNum) && t.AccountNum && t.AccountNum != "") {
          //查找供应商公司编码
          let _company = _.find(
            this.$store.state.biz_data.baseData.CompanyInfo,
            { VenderAccountNum: t.AccountNum }
          )

          if (_company) {
            _companyid = _company.DataArea
            let _p = {
              dataAreaId: _companyid,
              ItemId: t.ItemId,
            }
            let _is_ok =
              await saleOrderDispatchAddController.methods.checkIsInventInVender(
                _p
              )
            if (!_is_ok) {
              t._error = true
              this.$refs.saleOrderDispatch3.updateRowBackgroundColor(t)
            }
          }
        }
      })
    },
    //#region 附件
    async on_cell_button_click(data) {
      this.current_accessory = data.item
      if (data.field.key == "Accessory") {
        this.accessoryVisible = true
      }
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.SalesLineId)
    },
    setAccessory(data) {
      this.current_accessory.AccessoryCount = JSON.parse(data).length
      this.current_accessory.Accessory = data
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_sods_add_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 135rem;
}

.hb_table_sods_add_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 110rem;
}

.hb_table_sods_add_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 230rem;
}

.hb_table_vend_quote_add_class {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 160rem;
}

.hb_table_container_vend_quote {
  height: 100%;
}
</style>
<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
